import moment from 'moment'
import Vue from 'vue'

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(String(value)).format('YYYY-MM-DD hh:mm:ss')
    }
})

Vue.filter('formatDateTimeZH', function(value) {
    if (value) {
        return moment(String(value)).format('YYYY年MM月DD日 hh时mm分ss秒')
    }
})

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
    }
})

Vue.filter('formatDateZH', function(value) {
    if (value) {
        return moment(String(value)).format('YYYY年MM月DD日')
    }
})